import { registerSW } from 'virtual:pwa-register';

export type SwUpdateHandler = () => void;

let pendingUpdate: (() => Promise<void>) | null = null;
let updateHandler: SwUpdateHandler | null = null;

export function initServiceWorker() {
  const update = registerSW({
    immediate: false,
    onNeedRefresh() {
      updateHandler?.();
    },
    onOfflineReady() {
      // Shell precached — offline first-load will work.
    },
  });
  pendingUpdate = async () => {
    await update(true);
  };
}

export function onSwUpdate(handler: SwUpdateHandler) {
  updateHandler = handler;
}

export function applySwUpdate() {
  return pendingUpdate?.() ?? Promise.resolve();
}
